import { DateTime } from "luxon";
import { IModel, Model } from ".";
import { StringUtility } from "@common/utils";

export interface IIvlsDeviceModel extends IModel {
    ivlsDeviceId: number;
    hospitalId: number;
    deviceSerialNumber: string;
    displayName: string;
    lastPolledCloudTime: DateTime | undefined;


}

export class IvlsDeviceModel extends Model implements IIvlsDeviceModel {
    ivlsDeviceId: number;
    hospitalId: number;
    deviceSerialNumber: string;
    displayName: string;
    lastPolledCloudTime: DateTime | undefined;

    constructor(params: Partial<IIvlsDeviceModel> = {}) {
        super(params);
        const {
            ivlsDeviceId = 0,
            hospitalId = 0,
            deviceSerialNumber = '',
            displayName = '',
            lastPolledCloudTime = undefined,
        } = params;

        this.ivlsDeviceId = ivlsDeviceId;
        this.hospitalId = hospitalId;
        this.deviceSerialNumber = deviceSerialNumber;
        this.displayName = displayName;
        this.lastPolledCloudTime = lastPolledCloudTime;
        this.lastPolledCloudTime = lastPolledCloudTime ? StringUtility.SanitizeDateTimeISOAsUtc(lastPolledCloudTime.toString()) : undefined;
    }
}
